export default "__VITE_ASSET__hBussVLX__"